export const getAssetUrl = (url: string, assetsUrl?: string) => {
  const urlObj = new URL(url);
  const hostname = urlObj.hostname;

  return assetsUrl ? url.replace(hostname, assetsUrl) : url;
};
